import { render, staticRenderFns } from "./WarehouseDialog.vue?vue&type=template&id=87ae6dce"
import script from "./WarehouseDialog.vue?vue&type=script&lang=js"
export * from "./WarehouseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports